import React from 'react';
import { process } from '../../mock';

const Process = () => {
  return (
    <div className="grid lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] gap-12 lg:gap-16 items-start">
      {/* Left */}
      <div>
        <div className="label-mono text-ember mb-6">[{process.index}] · {process.label}</div>
        <h2 className="font-display font-light text-white text-3xl md:text-4xl lg:text-5xl leading-[1.1] tracking-tight">
          {process.headingLead}
          <span className="text-ember">{process.headingAccent}</span>
        </h2>
        <p className="mt-8 text-white/70 font-body text-base leading-relaxed">{process.body}</p>
      </div>

      {/* Right - 2x2 grid with connecting borders */}
      <div className="grid sm:grid-cols-2 border-t border-l border-white/10">
        {process.steps.map((s) => (
          <div
            key={s.no}
            data-testid={`process-step-${s.no}`}
            className="group p-8 border-b border-r border-white/10 transition-colors duration-300 hover:bg-white/[0.03]"
          >
            <div className="flex items-baseline gap-3">
              <span className="label-mono text-ember">{s.no}</span>
              <h3 className="font-display font-medium text-white text-2xl">{s.title}</h3>
            </div>
            <p className="mt-4 text-white/60 font-body text-sm leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Process;
